import React, { useEffect, useState } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { Container } from "reactstrap";
import { AdminNavbar } from "components/Navbars/components";
import { AdminFooter } from "components/Footers/components";
import { Sidebar } from "components/Sidebar";
import routes from "routes.js";
import axios from "utils/api";

const Admin = props => {
  //const [settings, setSettings] = useState([]);

  useEffect(() => {
    let mounted = true;
    
    if (mounted) {
      // axios.get(`settings/getbyid?id=1`)
      //   .then(response => {
      //     if (response)
      //       setSettings(response.data.settings);
      //   });
    }
  }, []);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === '/admin') {
        return (
          <Route
            path={`${prop.layout}${prop.path}`}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={routes[2].routes}
        logo={{
          innerLink: "/admin/index",
          imgSrc: "/logo/rcbc-transparent-v1.png",
          imgAlt: "Rizal Commercial Banking Corporation"
        }}
      />
      <div className="main-content">
        <AdminNavbar
          {...props}
        />
        <Switch>
          {getRoutes(routes[2].routes)}
          <Redirect from="*" to="/errors/error-404" />
        </Switch>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
}

export default Admin;
